import { render, staticRenderFns } from "./ChildDataRow.vue?vue&type=template&id=4a111b62&scoped=true&"
import script from "./ChildDataRow.vue?vue&type=script&lang=js&"
export * from "./ChildDataRow.vue?vue&type=script&lang=js&"
import style0 from "./ChildDataRow.vue?vue&type=style&index=0&id=4a111b62&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a111b62",
  null
  
)

export default component.exports